import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    header:
      'heading-xs text-secondary-hover flex items-center justify-between gap-5',
    author: 'overflow-hidden text-ellipsis whitespace-nowrap',
    text: 'sm:heading-xl heading-m-bold mt-3',
    response: 'mt-4'
  }
});
